import Grid from "@mui/material/Grid"
import { memo } from "react"
import styles from "./styles.module.scss"

import SearchBar from "../SearchBar"

const AnimeFilters = () => {
  return (
    <>
      <Grid item xs={12}>
        <h5 className={styles.filterTitle}>Search</h5>
        <SearchBar />
      </Grid>
      <div className={styles.separator}></div>
    </>
  )
}
export default memo(AnimeFilters)
